import { overwriteStore } from "../../actions/globalActions";
import type { Entry } from "../../types/dataTypes";
import type { GlobalState } from "../../types/stateTypes";
import type { Dispatch } from "redux";
import { sessionFromBundleMeta } from "./wrpfSessionActions";
import type { OpenlifterBundleFile, WrpfBundleMeta } from "./types";
import { defaultWrpfLiveState } from "../live/platformLiveProfile";
import { normalizeEntryDivisions, normalizeMeetDivisions } from "./normalizeWrpfDivisions";
import { wrapsOnlyAffectSquatEnabled } from "../../logic/equipmentForEvent";
import { baselineFromBundle } from "./pullFromWeb";

export function buildStoreFromWrpfBundle(bundle: OpenlifterBundleFile, wrpf: WrpfBundleMeta): GlobalState {
  const meet = bundle.meet as GlobalState["meet"];
  const registration = bundle.registration as GlobalState["registration"];

  return {
    versions: bundle.versions as GlobalState["versions"],
    language: bundle.language as GlobalState["language"],
    // Reglamento WRPF Argentina: bundles viejos traían bandas Master de 4-5 años (M40-44...);
    // acá se normalizan a las bandas de 10 años para que Resultados agrupe bien.
    meet: {
      ...meet,
      divisions: normalizeMeetDivisions(meet.divisions ?? []),
      wrapsOnlyAffectSquat: wrapsOnlyAffectSquatEnabled(meet),
    },
    registration: {
      ...registration,
      entries: registration.entries.map((e) => normalizeEntryDivisions(e as Entry)),
    },
    lifting: bundle.lifting as GlobalState["lifting"],
    // La base de "Traer cambios de la web" arranca en lo que trajo este bundle.
    wrpfSession: { ...sessionFromBundleMeta(wrpf), webBaseline: baselineFromBundle(bundle) },
    wrpfRecords: {
      tournamentScope: wrpf.tournamentScope ?? null,
      recordCategories: wrpf.recordCategories ?? [],
      currentRecords: wrpf.currentRecords ?? [],
    },
    wrpfLive: defaultWrpfLiveState(),
  };
}

export function applyWrpfBundle(dispatch: Dispatch, bundle: OpenlifterBundleFile, wrpf: WrpfBundleMeta): void {
  const storePayload = buildStoreFromWrpfBundle(bundle, wrpf);
  dispatch(overwriteStore(storePayload));
}
